<button
  matRipple
  (click)="download()"
  class="button"
  [disabled]="!downloadLink"
  [title]="buttonTitle | translate"
>
  {{ "download.download_mediaItem" | translate }}
</button>
